export enum TipoSimulacao {
  planejamento = 1,
  planejamentoPorEsferaAdmEstadual = 2,
  planejamentoPorEsferaAdmMunicipal = 3,
  planejamentoEstado = 4,
  planejamentoCidade = 5,
  planejamentoNacional = 6,
  financiamentoEntidadesFederadasPorEsferaAdmMunicipal = 7,
  financiamentoEntidadesFederadasPorEsferaAdmEstadual = 8,
  financiamentoEntidadesFederadasAgrupadoPorCidadeOuEstado = 9,
  financiamentoNacional = 10,
  financiamentoEscolaNacional = 11,
  caq = 12
}